/**
 * Mock Meraki networks — used by the network selector before
 * `/api/meraki/networks/` is wired. Mix of vendors and product types so
 * the UI exercises every branch (single product, multi-product, etc).
 */
import type { MerakiNetwork } from "@/api/schemas/meraki";

export const MOCK_MERAKI_NETWORKS: MerakiNetwork[] = [
  {
    id: "L_111111111111111111",
    name: "marriott-nyc-21-prod",
    organizationId: "O_111",
    organizationName: "GuestTek · Marriott",
    productTypes: ["appliance", "switch", "wireless"],
    deviceCount: 14,
  },
  {
    id: "L_222222222222222222",
    name: "hilton-lax-04-prod",
    organizationId: "O_222",
    organizationName: "GuestTek · Hilton",
    productTypes: ["appliance", "wireless"],
    deviceCount: 8,
  },
  {
    id: "L_333333333333333333",
    name: "hyatt-chi-07-prod",
    organizationId: "O_333",
    organizationName: "GuestTek · Hyatt",
    productTypes: ["switch", "wireless"],
    deviceCount: 11,
  },
  {
    id: "L_444444444444444444",
    name: "sofitel-par-09-prod",
    organizationId: "O_444",
    organizationName: "GuestTek · Accor",
    productTypes: ["appliance", "switch", "wireless", "camera"],
    deviceCount: 22,
  },
  {
    id: "L_555555555555555555",
    name: "lab-slc-01-staging",
    organizationId: "O_LAB",
    organizationName: "GuestTek · Lab",
    productTypes: ["appliance", "switch", "wireless"],
    deviceCount: 4,
  },
];
